import type { PoolOfferConfig } from '../../lib/api/operatorConsole';
import { CustomMark } from './CustomMark';
import { PercentInput } from './PercentInput';
import {
  levelRtpOverride,
  MAX_LOOT_RTP,
  pricingPatchForLevelRtp,
  rtpEffective,
  type PricingPatch,
  type RtpLevel,
} from './pricing';

type Props = {
  config: PoolOfferConfig;
  level: RtpLevel;
  name: string;
  onSave: (poolOfferId: number, patch: PricingPatch) => Promise<boolean | void>;
};

/** RTP of one volatility level: its own once set, else the Normal RTP shown muted. */
export function LevelRtpCell({ config, level, name, onSave }: Props) {
  const own = levelRtpOverride(config, level);

  return (
    <>
      <PercentInput
        label={`${level.label} RTP for ${name}`}
        value={own ?? rtpEffective(config)}
        max={MAX_LOOT_RTP}
        inherited={own == null}
        inheritedHint="Same as Normal. Type a value to set this level's own RTP."
        onCommit={(v) => onSave(config.pool_offer_id, pricingPatchForLevelRtp(config, level, v))}
      />
      {own != null && (
        <CustomMark
          label={`Reset ${level.label} RTP for ${name} to the Normal RTP`}
          onReset={() => void onSave(config.pool_offer_id, pricingPatchForLevelRtp(config, level, null))}
        />
      )}
    </>
  );
}
